import React from 'react'
import { withTheme } from 'styled-components';

import ic_add from 'App/assets/images/ic_add.png'
import ic_comment from 'App/assets/images/ic_comment.png'
import ic_doc from 'App/assets/images/ic-file-doc.png'
import ic_sheet from 'App/assets/images/ic-file-sheet.png'
import ic_pdf from 'App/assets/images/ic-file-pdf.png'
import ic_image from 'App/assets/images/ic-file-image.png'

import { ButtonReg } from 'atoms/Buttons'
import { FormTxtArea } from 'atoms/Inputs'
import Icon from 'atoms/Icon';
import IconPng from 'atoms/IconPng';
import { Label } from 'atoms/Texts'
import {
  MainWrapper,
  Head,
  LevelRowContainer,
  ModalFooter,
  ButtonAdd,
  File,
} from './styles'

const FILE_TYPES = {
  '.jpg': ic_image,
  '.png': ic_image,
  '.doc': ic_doc,
  '.docx': ic_doc,
  '.xls': ic_sheet,
  '.xlsx': ic_sheet,
  '.pdf': ic_pdf,
}

const CloseTaskModal = ({
  theme,
  data,
  task,
  isDisabled,
  isClosing,
  isContractor,
  fnSwitch,
  fnChange,
  fnRemoveEvidence,
  fnSubmit
}) => (
  <MainWrapper>
    <Head>
      <IconPng srcIcon={ic_comment} size={'auto'} h={'120'} mb={'20px'} />
      <Label lineheight={'29px'} size={'20px'} mb={'10px'}>
        Final Comment
      </Label>
      <Label lineheight={'29px'} size={'18px'} mb={'0px'} color={theme.mocaOrange} style={{ textAlign: 'center' }}>
        {task.title}
      </Label>
    </Head>
    <LevelRowContainer>
      {
        isContractor ?
          <>
            <div className="col-12">
              <Label lineheight={'14px'} size={'12px'}>
                Root Cause*
              </Label>
              <FormTxtArea
                placeholder={'Enter root cause'}
                rows="3"
                mb={'16px'}
                width="100%"
                value={data.rootCause}
                onChangeVal={e => fnChange(e.target.value, 'rootCause')}
              />
            </div>
            <div className="col-12">
              <Label lineheight={'14px'} size={'12px'}>
                Corrective*
              </Label>
              <FormTxtArea
                placeholder={'Enter corrective'}
                rows="3"
                mb={'16px'}
                width="100%"
                value={data.corrective}
                onChangeVal={e => fnChange(e.target.value, 'corrective')}
              />
            </div>
            <div className="col-12">
              <Label lineheight={'14px'} size={'12px'}>
                Preventive
              </Label>
              <FormTxtArea
                placeholder={'Enter preventive'}
                rows="3"
                mb={'16px'}
                width="100%"
                value={data.preventive}
                onChangeVal={e => fnChange(e.target.value, 'preventive')}
              />
            </div>
          </> :
          <div className="col-12">
            <Label lineheight={'14px'} size={'12px'}>
              Remark*
            </Label>
            <FormTxtArea
              placeholder={'Enter remark'}
              mb={'16px'}
              width="100%"
              value={data.remark}
              onChangeVal={e => fnChange(e.target.value, 'remark')}
            />
          </div>
      }
      <div className="col-12">
        <Label lineheight={'14px'} size={'12px'}>
          Evidence
        </Label>
        <div>
          <div>
            <ButtonAdd
              src={ic_add}
              onClick={() => document.getElementById('evidence').click()}
            />
          </div>
          <input
            id="evidence"
            type="file"
            accept={Object.keys(FILE_TYPES).join(',')}
            onChange={e => fnChange(e.target.files, 'evidences')}
            multiple
            hidden
          />
          {
            data.evidences.map((e, i) => (
              <File key={i}>
                <IconPng srcIcon={FILE_TYPES[e.type]} size={'auto'} h={'24'} mr={'20px'} />
                <Label lineheight={'14px'} size={'12px'} mb="0">
                  {e.name}
                </Label>
                <Icon
                  ml="auto"
                  name="times-circle"
                  color={theme.mocaRed}
                  onClick={() => fnRemoveEvidence(i)}
                  showPointer
                />
              </File>
            ))
          }
        </div>
      </div>
    </LevelRowContainer>

    <ModalFooter>
      <ButtonReg
        onClick={fnSwitch}
        btnTxt="Cancel"
        transparent
      />
      <ButtonReg
        onClick={fnSubmit}
        disabled={isDisabled}
        btnTxt={isClosing ? 'Closing...' : 'Close Issue'}
      />
    </ModalFooter>
  </MainWrapper>
)

export default withTheme(CloseTaskModal)
